import {StudyStat} from '../model/domain/StudyStat';
import {pipe} from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import {debug} from '../util/logger';
import {
  ReviewProgress,
  zeroReviewProgress,
} from '../model/domain/ReviewProgress';

const numberOfCardsToReviewToday = (stat: O.Option<StudyStat>): number =>
  pipe(
    stat,
    O.map((s: StudyStat) => s.n),
    O.getOrElse(() => 0),
  );

const computeProgress = (stat: StudyStat): ReviewProgress => {
  const leftToReview = stat.n;
  const reviewed = stat.done;
  const total = stat.done + leftToReview;
  const res = {...{reviewed, total}} as ReviewProgress;
  debug('Current progress: ', res);
  return res;
};

const getProgressOrZero = (stat: O.Option<StudyStat>): ReviewProgress =>
  pipe(
    stat,
    O.map(computeProgress),
    O.getOrElse(() => zeroReviewProgress),
  );

const hasAssignedCards = (stat: O.Option<StudyStat>): boolean =>
  pipe(
    stat,
    O.map((s: StudyStat) => s.hasAssignedCards),
    O.getOrElse<boolean>(() => false),
  );

export default {
  numberOfCardsToReviewToday,
  getProgressOrZero,
  hasAssignedCards,
};
